<template>
  <van-row class="page-wrapper" justify="center">
    <van-col class="itserve-center mb-25" span="24">
      <!--      <router-link :to="{ name: 'StripePayment' }">-->
      <!--        <van-notice-bar v-if="status === 0" color="red"-->
      <!--                        left-icon="volume-o" >-->
      <!--          {{ $t("notice-bar.fr                                                                                                                                                                                                                                                                                                                                                                                                           ee") }}-->
      <!--        </van-notice-bar>-->
      <!--        <van-notice-bar v-else color="#1989fa"-->
      <!--                        left-icon="volume-o" >-->
      <!--          {{ $t("notice-bar.premium") }}-->
      <!--        </van-notice-bar>-->
      <!--      </router-link>-->
      <van-notice-bar
          class="donora-notice-bar"
          color="#ffffff"
          background="#239B5B"
          :scrollable="true"
          :speed="45"
          @click="openDonoraNoticeUrl"
      >
        <template #left-icon>
          <span class="donora-notice-heart" aria-hidden="true">❤️</span>
        </template>
        {{ $t("notice-bar.donoraHelp") }}
      </van-notice-bar>
      <!--
      <div v-if="account && !hideFloatingGift" class="account-gift-fixed">
        <idea-bank-floating-gift />
      </div>
      -->
      <template v-if="isLoading">
        <!-- Скелетон для отображения во время загрузки -->
        <div class="white-wrapper place-content-center mt-15 top-radius">
          <div class="apply-loader">
            <Image
              col="0"
              src="~/img/logo.png"
              width="300"
              marginTop="20"
              stretch="aspectFill"
              class="company-logo m-t-10"
            />
          </div>
        </div>
        <div class="account-skeleton place-content-center">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
      </template>
      <template v-else-if="account">
        <div class="white-wrapper place-content-center mt-15 top-radius">
          <div class="apply-loader">
            <Image
              col="0"
              src="~/img/logo.png"
              width="300"
              marginTop="20"
              stretch="aspectFill"
              class="company-logo m-t-10"
            />
          </div>
        </div>
        <account ref="accountComponent" :account="account" :show-balance="true" class="place-content-center" />
        <itserve-route
          route-name="Pay"
          :params="$route.params"
          :buttonName="$t('buttons.pay')"
          type="wide"
          class="mt-15"
        ></itserve-route>
      </template>
      <div class="main-page-account account-menu-modern">
        <div class="account-feature-grid">
          <router-link
            :to="{ name: 'Donora', params: $route.params }"
            class="account-feature-card account-feature-donora"
          >
            <span class="account-feature-icon account-feature-logo">
              <img :src="edopomogaLogo" alt="" />
            </span>
            <span class="account-feature-label">
              <span class="account-feature-title">{{ $t("buttons.edopomoga") }}</span>
              <span class="account-feature-arrow">›</span>
            </span>
          </router-link>

          <button
            v-if="account"
            class="account-feature-card account-feature-indications"
            type="button"
            @click="openSendIndicationsForm"
          >
            <span class="account-feature-icon">
              <svg
                class="meter-feature-icon"
                viewBox="0 0 64 64"
                aria-hidden="true"
              >
                <rect x="14" y="8" width="36" height="46" rx="9" />
                <rect x="20" y="15" width="24" height="15" rx="3" />
                <path d="M24 22h16" />
                <circle cx="25" cy="39" r="2.4" />
                <circle cx="32" cy="39" r="2.4" />
                <circle cx="39" cy="39" r="2.4" />
                <path d="M23 47h18" />
                <path d="M24 54v4M32 54v4M40 54v4" />
              </svg>
            </span>
            <span class="account-feature-label">
              <span class="account-feature-title">{{ $t("buttons.putIndications") }}</span>
              <span class="account-feature-arrow">›</span>
            </span>
          </button>
        </div>

        <h2 class="account-actions-title">{{ $t("accountMenu.otherActions") }}</h2>

        <div class="account-actions-list">
          <router-link
            :to="{ name: 'PaymentHistoryResults', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <rect x="12" y="16" width="40" height="36" rx="8" />
                <path d="M21 10v10M43 10v10M13 27h38" />
                <path d="M22 36h6M32 36h6M42 36h4M22 44h6M32 44h6" />
              </svg>
            </span>
            <span>{{ $t("buttons.paymentHistory") }}</span>
          </router-link>

          <router-link
            :to="{ name: 'IndicatorsHistorySearchResults', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path d="M15 12h34v40H15z" />
                <path d="M23 22h18M23 31h18M23 40h10" />
                <path d="m39 42 4 4 8-10" />
              </svg>
            </span>
            <span>{{ $t("buttons.indicationsHistory") }}</span>
          </router-link>

          <button class="account-action-row" type="button" @click="runEasyPayAllService">
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path d="M10 31 32 13l22 18" />
                <path d="M17 29v24h30V29" />
                <path d="M27 53V39h10v14M23 34h6M35 34h6" />
              </svg>
            </span>
            <span>{{ $t("buttons.EasyPayAllService") }}</span>
          </button>

          <router-link
            :to="{ name: 'WriteTicket', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path d="M20 14h24a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H30L18 53v-9h-2a8 8 0 0 1-8-8V22a8 8 0 0 1 8-8Z" />
                <path d="M23 27h18M23 35h12" />
              </svg>
            </span>
            <span>{{ $t("buttons.contactUs") }}</span>
          </router-link>

          <button class="account-action-row" type="button" @click="socialShare">
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <circle cx="18" cy="32" r="7" />
                <circle cx="46" cy="18" r="7" />
                <circle cx="46" cy="46" r="7" />
                <path d="m24 29 16-8M24 35l16 8" />
              </svg>
            </span>
            <span>{{ $t("buttons.socialShare") }}</span>
          </button>

          <button class="account-action-row" type="button" @click="runRate">
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path d="m32 10 6.5 13.2 14.5 2.1-10.5 10.2 2.5 14.4L32 43l-13 6.9 2.5-14.4L11 25.3l14.5-2.1Z" />
              </svg>
            </span>
            <span>{{ $t("buttons.rateApp") }}</span>
          </button>
        </div>

        <!--
        <div v-if="account" class="account-offer-top-spacer"></div>
        <div v-if="account" class="account-offer-wrap">
          <idea-bank-home-banner
            ref="accountOfferBanner"
            class="account-offer-banner"
          />
        </div>
        <div v-if="account" class="account-offer-bottom-spacer"></div>
        -->
      </div>
    </van-col>
  </van-row>
</template>
<script>
// import IdeaBankFloatingGift from "@/components/idea-bank/IdeaBankFloatingGift";
// import IdeaBankHomeBanner from "@/components/idea-bank/IdeaBankHomeBanner";
import edopomogaLogo from "@/assets/images/edopomoga-logo-Photoroom.png";
import { getDonoraUrl } from "@/views/account/edopomoga/donoraLinks";
import ItserveRoute from "@/components/content/ItserveRoute";
import Account from "@/components/helpers/Account";
// import PayIcon from "@/components/icons/pay-icon-box";
// import ShutdownIcon from "@/components/icons/shutdown-icon-box";
// import ElectricIcon from "@/components/icons/electric-icon-box";
// import ItserveButton from "@/components/forms/ItserveButton";
// import DollarSignIcon from "@/components/icons/dollar-sign-icon";
import VanNoticeBar from "vant/lib/notice-bar/index";
export default {
  name: "Index",
  components: {
    // IdeaBankFloatingGift,
    // IdeaBankHomeBanner,
    // ItserveButton,
    // ElectricIcon,
    // ShutdownIcon,
    // PayIcon,
    Account,
    ItserveRoute,
    // DollarSignIcon,
    VanNoticeBar,
  },
  data() {
    return {
      easyPayUrl: "https://easypay.ua/ua/partner-frame/serve/catalog/utility",
      appName: "",
      shareAppName: "",
      CHLENIX: "",
      isLoading: false,
      hideFloatingGift: false,
      giftObserver: null,
      edopomogaLogo,
    };
  },
  computed: {
    shareStatus() {
      console.log("USER SHARE STATUS: " + this.$store.state.Auth.share_status);
      return this.$store.state.Auth.share_status;
    },
    account() {
      return this.$store.state.Auth.account;
    },
    status() {
      console.log("USER STATUS: " + this.$store.state.Auth.status);
      return this.$store.state.Auth.status;
    },
    status_sub() {
      return this.$store.state.Auth.status_sub;
    },
  },
  watch: {
    account(value) {
      if (value) {
        this.$nextTick(this.setupGiftObserver);
      } else {
        this.teardownGiftObserver();
      }
    },
  },
  created() {
    this.getPageData();
    this.getHistory();
    this.utilityUrl();
    this.noticeBarAppName();
    this.preloadInterstitial();
  },
  mounted() {
    this.$nextTick(this.setupGiftObserver);
  },
  beforeDestroy() {
    this.teardownGiftObserver();
  },
  methods: {
    setupGiftObserver() {
      this.teardownGiftObserver();

      if (!this.account || !this.$refs.accountOfferBanner) {
        this.hideFloatingGift = false;
        return;
      }

      if (typeof IntersectionObserver === "undefined") {
        this.hideFloatingGift = false;
        return;
      }

      const target =
        this.$refs.accountOfferBanner.$el || this.$refs.accountOfferBanner;

      this.giftObserver = new IntersectionObserver(
        (entries) => {
          this.hideFloatingGift = entries.some((entry) => entry.isIntersecting);
        },
        {
          root: null,
          rootMargin: "0px 0px -24px 0px",
          threshold: 0,
        }
      );
      this.giftObserver.observe(target);
    },
    teardownGiftObserver() {
      if (this.giftObserver) {
        this.giftObserver.disconnect();
        this.giftObserver = null;
      }
    },
    preloadInterstitial() {
      if (!this.$store.state.Auth.isPreloaded && !this.$store.state.Auth.status_sub && this.$store.state.Auth.app_id !== "lviv.gas") {
        console.log("preloadInterstitial CALL!!!!");
        this.nativeSendEvent("preloadInterstitial");
        this.$store.state.Auth.isPreloaded = true;
      }
    },
    // preloadInterstitial() {
    //   if (!this.$store.state.Auth.isPreloaded) {
    //     try {
    //       let adWatched = false;
    //
    //       this.nativeSendEvent("preloadInterstitialRewarded");
    //
    //       this.nativeWaitForEvent("ResponseRewardedInterstitialAd", () => {
    //
    //         adWatched = true;
    //
    //         this.$store.state.Auth.isPreloaded = true;
    //       });
    //
    //       setTimeout(() => {
    //         if (!adWatched) {
    //
    //           this.nativeSendEvent("preloadInterstitial");
    //           this.$store.state.Auth.isPreloaded = true;
    //         }
    //       }, 11000);
    //     } catch (error) {
    //       console.error("An error occurred while triggering preloadInterstitialRewarded:", error.message);
    //     }
    //   }
    // },
    noticeBarAppName() {
      let id = this.$store.state.Auth.app_id;
      let locale = this.$store.state.Auth.locale;
      let text;

      switch (id) {
        case "zaporizhzhia.gas":
          text = this.getLocalizedText(locale, {
            uk: "Запоріжжя енерго",
            ru: "Запорожье энерго",
            en: "Zaporizhzhia energo",
          });
          break;
        case "lviv.gas":
          text = this.getLocalizedText(locale, {
            uk: "Львів енерго",
            ru: "Львов энерго",
            en: "Lviv energo",
          });
          break;
        case "volyn.gas":
          text = this.getLocalizedText(locale, {
            uk: "Волинь енерго",
            ru: "Волынь энерго",
            en: "Volyn energo",
          });
          break;
        case "kherson.gas":
          text = this.getLocalizedText(locale, {
            uk: "Херсон енерго",
            ru: "Херсон энерго",
            en: "Kherson energo",
          });
          break;
        case "ternopil.gas":
          text = this.getLocalizedText(locale, {
            uk: "Тернопіль енерго",
            ru: "Тернополь энерго",
            en: "Ternopil energo",
          });
          break;
        case "chernivtsi.gas":
          text = this.getLocalizedText(locale, {
            uk: "Чернівці енерго",
            ru: "Черновцы энерго",
            en: "Chernivtsi energo",
          });
          break;
        case "prykarpattya.gas":
          text = this.getLocalizedText(locale, {
            uk: "Прикарпаття енерго",
            ru: "Прикарпатье энерго",
            en: "Prykarpattya energo",
          });
          break;
        case "zakarpattya.gas":
          text = this.getLocalizedText(locale, {
            uk: "Закарпаття енерго",
            ru: "Закарпатье энерго",
            en: "Zakarpattya energo",
          });
          break;
        case "rivne.gas":
          text = this.getLocalizedText(locale, {
            uk: "Рівне енерго",
            ru: "Ровно энерго",
            en: "Rivne energo",
          });
          break;
        case "khmelnytskyi.gas":
          text = this.getLocalizedText(locale, {
            uk: "Хмельницький енерго",
            ru: "Хмельницкий энерго",
            en: "Khmelnytskyi energo",
          });
          break;
        case "vinnytsia.gas":
          text = this.getLocalizedText(locale, {
            uk: "Вінниця енерго",
            ru: "Винница энерго",
            en: "Vinnytsia energo",
          });
          break;
        case "cherkasy.gas":
          text = this.getLocalizedText(locale, {
            uk: "Черкаси енерго",
            ru: "Черкассы энерго",
            en: "Cherkasy energo",
          });
          break;
        case "chernihiv.gas":
          text = this.getLocalizedText(locale, {
            uk: "Чернігів енерго",
            ru: "Чернигов энерго",
            en: "Chernihiv energo",
          });
          break;
        case "mykolaiv.gas":
          text = this.getLocalizedText(locale, {
            uk: "Миколаїв енерго",
            ru: "Николаев энерго",
            en: "Mykolaiv energo",
          });
          break;
        case "dnipro.gas":
          text = this.getLocalizedText(locale, {
            uk: "Дніпро енерго",
            ru: "Днепр энерго",
            en: "Dnipro energo",
          });
          break;
        case "poltava.gas":
          text = this.getLocalizedText(locale, {
            uk: "Полтава енерго",
            ru: "Полтава энерго",
            en: "Poltava energo",
          });
          break;
        case "odesa.gas":
          text = this.getLocalizedText(locale, {
            uk: "Одеса енерго",
            ru: "Одесса энерго",
            en: "Odesa energo",
          });
          break;
        case "zhytomyr.gas":
          text = this.getLocalizedText(locale, {
            uk: "Житомир енерго",
            ru: "Житомир энерго",
            en: "Zhytomyr energo",
          });
          break;
        case "kirovograd.gas":
          text = this.getLocalizedText(locale, {
            uk: "Кіровоград енерго",
            ru: "Кировоград энерго",
            en: "Kirovohrad energo",
          });
          break;
        case "sumy.gas":
          text = this.getLocalizedText(locale, {
            uk: "Суми енерго",
            ru: "Сумы энерго",
            en: "Sumy energo",
          });
          break;
        case "kyiv.gas":
          text = this.getLocalizedText(locale, {
            uk: "Київ енерго",
            ru: "Киев энерго",
            en: "Kyiv energo",
          });
          break;
        case "kharkiv.gas":
          text = this.getLocalizedText(locale, {
            uk: "Харків енерго",
            ru: "Харьков энерго",
            en: "Kharkiv energo",
          });
          break;
        default:
          text = this.getLocalizedText(locale, {
            uk: "Харків енерго",
            ru: "Харьков энерго",
            en: "Kharkiv energo",
          });
      }
      console.log("LOCALE:", this.$store.state.Auth.locale)
      this.appName = text;
    },
    getLocalizedText(locale, links) {
      switch (locale) {
        case "uk":
          return links.uk;
        case "ru":
          return links.ru;
        case "en":
          return links.en;
        default:
          return links.uk; // значение по умолчанию, если язык не найден
      }
    },
    openEnergoUrl() {
      let id;
      let url;

      id = this.$store.state.Auth.app_id;
      switch (id) {
        case "zaporizhzhia.gas":
          url = "https://billing.city/zaporizhzhia.energo";
          break;
        case "lviv.gas":
          url = "https://billing.city/lviv.energo";
          break;
        case "volyn.gas":
          url = "https://billing.city/volyn.energo";
          break;
        case "kherson.gas":
          url = "https://billing.city/kherson.energo";
          break;
        case "ternopil.gas":
          url = "https://billing.city/ternopil.energo";
          break;
        case "chernivtsi.gas":
          url = "https://billing.city/chernivtsi.energo";
          break;
        case "prykarpattya.gas":
          url = "https://billing.city/prykarpattya.energo";
          break;
        case "zakarpattya.gas":
          url = "https://billing.city/zakarpattya.energo";
          break;
        case "rivne.gas":
          url = "https://billing.city/rivne.energo";
          break;
        case "khmelnytskyi.gas":
          url = "https://billing.city/khmelnytskyi.energo";
          break;
        case "vinnytsia.gas":
          url = "https://billing.city/vinnytsia.energo";
          break;
        case "cherkasy.gas":
          url = "https://billing.city/cherkasy.energo";
          break;
        case "chernihiv.gas":
          url = "https://billing.city/chernihiv.energo";
          break;
        case "mykolaiv.gas":
          url = "https://billing.city/mykolaiv.energo";
          break;
        case "dnipro.gas":
          url = "https://billing.city/dnipro.energo";
          break;
        case "poltava.gas":
          url = "https://billing.city/poltava.energo";
          break;
        case "odesa.gas":
          url = "https://billing.city/odesa.energo";
          break;
        case "zhytomyr.gas":
          url = "https://billing.city/zhytomyr.energo";
          break;
        case "kirovograd.gas":
          url = "https://billing.city/kirovograd.energo";
          break;
        case "sumy.gas":
          url = "https://billing.city/sumy.energo";
          break;
        case "kyiv.gas":
          url = "https://billing.city/kyiv.energo";
          break;
        case "kharkiv.gas":
          url = "https://billing.city/kharkiv.kharenergo2";
          break;
      }
      console.log("URL: ", url)
      this.nativeSendEvent("url", url);
    },
    openDonoraNoticeUrl() {
      this.nativeSendEvent(
        "url",
        getDonoraUrl(this.$store.state.Auth.app_id)
      );
    },
    async putIndications() {
      await this.$router.push({
        name: "RegionalEnergy",
        params: this.$route.params,
      });
      // if (this.shareStatus === 1) {
      //   await this.$router.push({
      //     name: "RegionalEnergy",
      //     params: this.$route.params,
      //   });
      // } else {
      //   await this.$router.push({
      //     name: "ShareAppBeforePutIndication",
      //     params: this.$route.params,
      //   });
      // }
    },
    async openSendIndicationsForm() {
      await this.$router.push({
        name: "SendIndicationContacts",
        params: this.$route.params,
      });
    },
    async runEasyPayAllService() {
      await this.$router.push({ name: "EasyPayAllServicePage",
        params: { easyPayUrl: this.easyPayUrl },
      });
      // if (this.shareStatus === 1) {
      //   console.log("CHLENIX!!!");
      //   await this.$router.push({ name: "EasyPayAllServicePage",
      //     params: { easyPayUrl: this.easyPayUrl },
      //   });
      // } else {
      //   await this.$router.push({
      //     name: "ShareApp",
      //     params: { easyPayUrl: this.easyPayUrl },
      //   });
      // }
    },
    runRate() {
      let id;
      let url;

      id = this.$store.state.Auth.app_id;
      switch (id) {
        case "zaporizhzhia.gas":
          url = "https://billing.city/zaporizhzhia.gas";
          break;
        case "lviv.gas":
          url = "https://billing.city/lviv.gas";
          break;
        case "volyn.gas":
          url = "https://billing.city/volyn.gas";
          break;
        case "kherson.gas":
          url = "https://billing.city/kherson.gas";
          break;
        case "ternopil.gas":
          url = "https://billing.city/ternopil.gas";
          break;
        case "chernivtsi.gas":
          url = "https://billing.city/chernivtsi.gas";
          break;
        case "prykarpattya.gas":
          url = "https://billing.city/prykarpattya.gas";
          break;
        case "zakarpattya.gas":
          url = "https://billing.city/zakarpattya.gas";
          break;
        case "rivne.gas":
          url = "https://billing.city/rivne.gas";
          break;
        case "khmelnytskyi.gas":
          url = "https://billing.city/khmelnytskyi.gas";
          break;
        case "vinnytsia.gas":
          url = "https://billing.city/vinnytsia.gas";
          break;
        case "cherkasy.gas":
          url = "https://billing.city/cherkasy.gas";
          break;
        case "chernihiv.gas":
          url = "https://billing.city/chernihiv.gas";
          break;
        case "mykolaiv.gas":
          url = "https://billing.city/mykolaiv.gas";
          break;
        case "dnipro.gas":
          url = "https://billing.city/dnipro.gas";
          break;
        case "poltava.gas":
          url = "https://billing.city/poltava.gas";
          break;
        case "odesa.gas":
          url = "https://billing.city/odesa.gas";
          break;
        case "zhytomyr.gas":
          url = "https://billing.city/zhytomyr.gas";
          break;
        case "kirovograd.gas":
          url = "https://billing.city/kirovograd.gas";
          break;
        case "sumy.gas":
          url = "https://billing.city/sumy.gas";
          break;
        case "kyiv.gas":
          url = "https://billing.city/kyiv.gas";
          break;
        case "kharkiv.gas":
          url = "https://billing.city/kharkiv.gas";
          break;
        default:
          url = "https://billing.city";
      }

      this.nativeSendEvent("url", url);
    },
    getLS() {
      const ls =
        this.$route.params.account ||
        this.$route.params.ls ||
        this.account?.ls ||
        this.account?.account_number ||
        this.account?.accountNumber ||
        this.account?.number;

      return {
        ls,
      };
    },
    async getHistory() {
      await this.$store.commit("PaymentHistory/SET_LS", this.getLS());
      await this.$store.dispatch("Auth/getStripeStatus");
      await this.$store.dispatch("PaymentHistory/getPaymentHistory");
    },
    async getPageData() {
      this.isLoading = true;
      try {
        await this.checkForCorrectParameters();
        await this.$store.dispatch("Payment/getCardsList");
        await this.$store.dispatch("Settings/getSettings");
        await this.$store.dispatch("Auth/getSubscriptionStatus");
        await this.$store.dispatch("Auth/getUserLS", this.account);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToExternalLink() {
      this.nativeSendEvent("url", "https://t.me/napulsi24");
    },
    async checkForCorrectParameters() {
      if (Object.keys(this.$route.params).length) {
        if (this.$route.params.account !== undefined) {
          this.isLoading = true;
          try {
            await this.$store.dispatch(
              "Auth/getUserAccount",
              this.$route.params.account
            );
          } finally {
            // Оставляем isLoading = true, так как общая загрузка еще не завершена
            // isLoading будет установлен в false в методе getPageData
          }
        } else {
          console.error(
            "WARNING: somehow user opened account page without provided account parameter!"
          );
          await this.$router.push({ name: "Home" });
        }
      } else {
        console.error(
          "WARNING: somehow user opened account page any parameters!"
        );
        await this.$router.push({ name: "Home" });
      }
    },
    socialShare() {
      let id;
      let url;
      let text;
      let locale;

      locale = this.$store.state.Auth.locale;
      id = this.$store.state.Auth.app_id;
      switch (id) {
        case "zaporizhzhia.gas":
          url = "https://billing.city/zaporizhzhia.gas";
          text = this.getLocalizedText(locale, {
            uk: "Запоріжжя газ",
            ru: "Запорожье газ",
            en: "Zaporizhzhia gas",
          });
          break;
        case "lviv.gas":
          url = "https://billing.city/lviv.gas";
          text = this.getLocalizedText(locale, {
            uk: "Львів газ",
            ru: "Львов газ",
            en: "Lviv gas",
          });
          break;
        case "volyn.gas":
          url = "https://billing.city/volyn.gas";
          text = this.getLocalizedText(locale, {
            uk: "Волинь газ",
            ru: "Волынь газ",
            en: "Volyn gas",
          });
          break;
        case "kherson.gas":
          url = "https://billing.city/kherson.gas";
          text = this.getLocalizedText(locale, {
            uk: "Херсон газ",
            ru: "Херсон газ",
            en: "Kherson gas",
          });
          break;
        case "ternopil.gas":
          url = "https://billing.city/ternopil.gas";
          text = this.getLocalizedText(locale, {
            uk: "Тернопіль газ",
            ru: "Тернополь газ",
            en: "Ternopil gas",
          });
          break;
        case "chernivtsi.gas":
          url = "https://billing.city/chernivtsi.gas";
          text = this.getLocalizedText(locale, {
            uk: "Чернівці газ",
            ru: "Черновцы газ",
            en: "Chernivtsi gas",
          });
          break;
        case "prykarpattya.gas":
          url = "https://billing.city/prykarpattya.gas";
          text = this.getLocalizedText(locale, {
            uk: "Прикарпаття газ",
            ru: "Прикарпатье газ",
            en: "Prykarpattya gas",
          });
          break;
        case "zakarpattya.gas":
          url = "https://billing.city/zakarpattya.gas";
          text = this.getLocalizedText(locale, {
            uk: "Закарпаття газ",
            ru: "Закарпатье газ",
            en: "Zakarpattya gas",
          });
          break;
        case "rivne.gas":
          url = "https://billing.city/rivne.gas";
          text = this.getLocalizedText(locale, {
            uk: "Рівне газ",
            ru: "Ровно газ",
            en: "Rivne gas",
          });
          break;
        case "khmelnytskyi.gas":
          url = "https://billing.city/khmelnytskyi.gas";
          text = this.getLocalizedText(locale, {
            uk: "Хмельницький газ",
            ru: "Хмельницкий газ",
            en: "Khmelnytskyi gas",
          });
          break;
        case "vinnytsia.gas":
          url = "https://billing.city/vinnytsia.gas";
          text = this.getLocalizedText(locale, {
            uk: "Вінниця газ",
            ru: "Винница газ",
            en: "Vinnytsia gas",
          });
          break;
        case "cherkasy.gas":
          url = "https://billing.city/cherkasy.gas";
          text = this.getLocalizedText(locale, {
            uk: "Черкаси газ",
            ru: "Черкассы газ",
            en: "Cherkasy gas",
          });
          break;
        case "chernihiv.gas":
          url = "https://billing.city/chernihiv.gas";
          text = this.getLocalizedText(locale, {
            uk: "Чернігів газ",
            ru: "Чернигов газ",
            en: "Chernihiv gas",
          });
          break;
        case "mykolaiv.gas":
          url = "https://billing.city/mykolaiv.gas";
          text = this.getLocalizedText(locale, {
            uk: "Миколаїв газ",
            ru: "Николаев газ",
            en: "Mykolaiv gas",
          });
          break;
        case "dnipro.gas":
          url = "https://billing.city/dnipro.gas";
          text = this.getLocalizedText(locale, {
            uk: "Дніпро газ",
            ru: "Днепр газ",
            en: "Dnipro gas",
          });
          break;
        case "poltava.gas":
          url = "https://billing.city/poltava.gas";
          text = this.getLocalizedText(locale, {
            uk: "Полтава газ",
            ru: "Полтава газ",
            en: "Poltava gas",
          });
          break;
        case "odesa.gas":
          url = "https://billing.city/odesa.gas";
          text = this.getLocalizedText(locale, {
            uk: "Одеса газ",
            ru: "Одесса газ",
            en: "Odesa gas",
          });
          break;
        case "zhytomyr.gas":
          url = "https://billing.city/zhytomyr.gas";
          text = this.getLocalizedText(locale, {
            uk: "Житомир газ",
            ru: "Житомир газ",
            en: "Zhytomyr gas",
          });
          break;
        case "kirovograd.gas":
          url = "https://billing.city/kirovograd.gas";
          text = this.getLocalizedText(locale, {
            uk: "Кіровоград газ",
            ru: "Кировоград газ",
            en: "Kirovohrad gas",
          });
          break;
        case "sumy.gas":
          url = "https://billing.city/sumy.gas";
          text = this.getLocalizedText(locale, {
            uk: "Суми газ",
            ru: "Сумы газ",
            en: "Sumy gas",
          });
          break;
        case "kyiv.gas":
          url = "https://billing.city/kyiv.gas";
          text = this.getLocalizedText(locale, {
            uk: "Київ газ",
            ru: "Киев газ",
            en: "Kyiv gas",
          });
          break;
        case "kharkiv.gas":
          url = "https://billing.city/kharkiv.gas";
          text = this.getLocalizedText(locale, {
            uk: "Харків газ",
            ru: "Харьков газ",
            en: "Kharkiv gas",
          });
          break;
      }
      console.log("SHARE URL: ", url)
      this.shareAppName = text;
      this.nativeSendEvent("socialShare", {
        text: this.$t("settings.title1") + this.shareAppName + this.$t("settings.title2") + url,
        subject: this.shareAppName,
      });
    },
    utilityUrl() {
      let id;
      let url;

      id = this.$store.state.Auth.app_id;
      switch (id) {
        case "zaporizhzhia.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/zaporizhia";
          break;
        case "lviv.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/lvivska-obl";
          break;
        case "volyn.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/lutsk";
          break;
        case "kherson.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/kherson";
          break;
        case "ternopil.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/ternopol";
          break;
        case "chernivtsi.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/chernivtsi";
          break;
        case "prykarpattya.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/ivano-frank-obl";
          break;
        case "zakarpattya.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/zakarpattya";
          break;
        case "rivne.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/rivne";
          break;
        case "khmelnytskyi.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/hmelnickiy";
          break;
        case "vinnytsia.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/vinnica";
          break;
        case "cherkasy.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/cherkasy";
          break;
        case "chernihiv.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/chernihiv";
          break;
        case "mykolaiv.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/mykolaiv";
          break;
        case "dnipro.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/dnepropetrovsk";
          break;
        case "poltava.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/poltava";
          break;
        case "odesa.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/odessa";
          break;
        case "zhytomyr.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/zhytomyrska-oblast";
          break;
        case "kirovograd.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/kirovograd";
          break;
        case "sumy.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/sumy";
          break;
        case "kyiv.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/kiev";
          break;
        case "kharkiv.gas":
          url =
            "https://easypay.ua/ua/partner-frame/serve/catalog/utility/harkov";
          break;
        default:
          url = "https://easypay.ua/ua/partner-frame/serve/catalog/utility";
      }
      this.easyPayUrl = url;
    },
  },
};
</script>

<style scoped>
.account-skeleton {
  background-color: #1e1e1e;
  border-radius: 15px;
  padding: 20px;
  margin: 15px auto;
  max-width: 337px;
  width: 100%;
}

.skeleton-line {
  height: 20px;
  background: linear-gradient(90deg, #333 25%, #444 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-line:nth-child(1) {
  width: 80%;
}

.skeleton-line:nth-child(2) {
  width: 90%;
}

.skeleton-line:nth-child(3) {
  width: 70%;
}

.skeleton-line:nth-child(4) {
  width: 60%;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
<style scoped>
@import "../../../node_modules/vant/lib/dialog/index.css";
@import "../../../node_modules/vant/lib/overlay/index.css";
@import "../../../node_modules/vant/lib/popup/index.css";
.page-wrapper {
  padding-bottom: calc(44px + env(safe-area-inset-bottom, 0px));
}

.main-page-account {
  width: min(337px, calc(100vw - 32px));
  margin: 0 auto;
  padding: 14px 0 12px;
}

.main-page-account.place-content-center {
  overflow: visible;
}

.account-menu-modern,
.account-menu-modern * {
  box-sizing: border-box;
}

.account-feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
}

.account-feature-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 146px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  padding: 16px 18px 18px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  background: #0e121b;
  color: #ffffff;
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  text-align: left;
  text-decoration: none;
}

.account-feature-card::before {
  display: none;
}

.account-feature-card::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  background: #4285f4;
  box-shadow: 0 0 16px rgba(66, 133, 244, 0.62);
}

.account-feature-donora {
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.account-feature-donora::after {
  background: #38c986;
}

.account-feature-indications {
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.account-feature-card[type="button"] {
  font: inherit;
}

.account-feature-card > * {
  position: relative;
  z-index: 1;
}

.account-feature-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(66, 133, 244, 0.22);
  color: #ffffff;
}

.account-feature-icon svg {
  width: 31px;
  height: 31px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-feature-icon .meter-feature-icon {
  width: 34px;
  height: 34px;
  stroke-width: 3;
}

.account-feature-icon::v-deep svg {
  width: 31px;
  height: 31px;
}

.account-feature-logo {
  border-radius: 12px;
  background: #000000;
}

.account-feature-logo img {
  width: 46px;
  height: 46px;
  display: block;
  object-fit: contain;
}

.account-feature-label {
  width: 100%;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.account-feature-title {
  min-width: 0;
  display: block;
  padding-right: 0;
  color: #ffffff;
  font-family: inherit;
  font-size: clamp(16px, 4.1vw, 17.5px);
  font-weight: 760;
  line-height: 1.14;
  overflow-wrap: normal;
  word-break: normal;
}

.account-feature-arrow {
  flex: 0 0 auto;
  color: #4285f4;
  font-size: 32px;
  font-weight: 250;
  line-height: 1;
}

.account-feature-donora .account-feature-arrow {
  color: #38c986;
}

.account-actions-title {
  margin: 18px 0 12px;
  color: #ffffff;
  font-family: inherit;
  font-size: 19px;
  font-weight: 760;
  line-height: 1.1;
  text-align: left;
}

.account-actions-list {
  overflow: hidden;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  background: #0e121b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.account-action-row {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 11px 18px;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: #0e121b;
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  text-align: left;
  text-decoration: none;
}

.account-action-row:last-child {
  border-bottom: 0;
}

.account-action-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #1a2942;
  color: #ffffff;
}

.account-action-icon svg {
  width: 27px;
  height: 27px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-action-icon::v-deep svg,
.account-action-icon::v-deep .material-design-icon {
  width: 27px;
  height: 27px;
}

.account-action-row span:last-child {
  min-width: 0;
  color: #ffffff;
  font-family: inherit;
  font-size: clamp(16px, 4.2vw, 18px);
  font-weight: 740;
  line-height: 1.18;
}

.donora-notice-bar {
  min-height: 40px;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
  cursor: pointer;
}

.donora-notice-bar::v-deep .van-notice-bar__content {
  color: #ffffff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.18);
}

.donora-notice-heart {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  font-size: 16px;
  line-height: 1;
}

.account-gift-fixed {
  position: fixed;
  left: 50%;
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  z-index: 30;
  display: flex;
  justify-content: flex-end;
  width: min(337px, calc(100vw - 32px));
  transform: translateX(calc(-50% + 10px));
  pointer-events: none;
}

.account-gift-fixed > * {
  pointer-events: auto;
}

.account-offer-wrap {
  clear: both;
  width: min(369px, calc(100vw - 4px));
  margin-left: 50%;
  padding: 0 16px;
  transform: translateX(-50%);
  overflow: visible;
  box-sizing: border-box;
  filter: drop-shadow(0 0 14px rgba(56, 189, 248, 0.22));
}

.account-offer-banner {
  margin-top: 0;
  margin-bottom: 0;
}

.account-offer-top-spacer {
  clear: both;
  width: 100%;
  height: 15px;
  flex-shrink: 0;
}

.account-offer-bottom-spacer {
  width: 100%;
  height: calc(36px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
}

.edopomoga-menu-icon {
  width: 52px;
  height: 52px;
  display: block;
  border: 0;
  object-fit: contain;
  object-position: center;
}

.page-type {
  padding: 15px 0 0 0;
  font-size: 18px;
  margin: 0;
  color: #0b0b0b;
  background-color: #fff;
}

.top-radius {
  border-radius: 15px 15px 0 0;
}

@media (max-width: 340px) {
  .nav-btn {
    width: 50%;
  }
}
</style>
